// import React, { useEffect, useState } from 'react';
// import styled, { keyframes } from 'styled-components';


// const Container = styled.div`
//   background: #292d2e;
//     margin:6px 0px;
//   color: white;
//   padding: 12px;
//   border-radius: 20px;
//   font-family: Arial, sans-serif;
//   width: 100%;
//   overflow-x: auto;
  
//   @media (max-width: 768px) {
//     padding: 8px;
//   }
// `;

// const TabSwitcher = styled.div`
//   display: flex;
//   margin-bottom: 20px;
//    background: #292d2e;
//   border-radius:24px;
  
//   @media (max-width: 768px) {
//     margin-bottom: 12px;
//   }
// `;

// const Tab = styled.button`
//   // background: linear-gradient(
//   //     to right, 
//   //     #2A5B5A, 
//   //     #1C3D3C
//   //   );
//   background-color:transparent;
//   color: white;
//   border: none;
//   padding: 10px 20px;
//   border-radius: 20px;
//   cursor: pointer;
//   font-size: 14px;
//   font-weight: bold;
//   margin-right: 10px;
  
//   @media (max-width: 768px) {
//     padding: 8px 16px;
//     font-size: 12px;
//   }
// `;

// const TableWrapper = styled.div`
//   width: 100%;
//   overflow-x: auto;
//   -webkit-overflow-scrolling: touch;
// `;

// const Table = styled.table`
//   width: 100%;
//   min-width: auto;
//   border-collapse: separate;
//   border-spacing: 0 4px;
  
//   @media (max-width: 768px) {
//     font-size: 12px;
//   }
// `;

// const TableHeader = styled.th`
//   text-align: left;
//   padding: 10px 20px;
//   color: #8a8d92;
//   font-weight: normal;
//   white-space: nowrap;
//    font-size: 16px;
  
//   @media (max-width: 768px) {
//     padding: 6px;
//     font-size: 11px;
//   }
// `;

// const TableCell = styled.td`
//  padding: 10px 20px;
//   white-space: nowrap;
//   max-width: 100px;
//   overflow: hidden;
//   text-overflow: ellipsis;
//    font-size: 16px;
  
//   @media (max-width: 768px) {
//     padding: 6px;
//     font-size: 11px;
    
//     &.game-cell {
//       max-width: 60px;
//     }
    
//     &.betid-cell {
//       max-width: 80px;
//     }
//   }
// `;

// const RaceInfo = styled.div`
//   display: flex;
//   justify-content: space-between;
//   margin-bottom: 20px;
//   color: #8a8d92;
//   flex-wrap: wrap;
//   gap: 10px;
// `;

// const GreenText = styled.span`
//   color: #4caf50;
  
//   @media (max-width: 768px) {
//     font-size: 11px;
//   }
// `;

// const RankIcon = styled.div`
//   width: 24px;
//   height: 24px;
//   background-color: ${props => props.rank <= 3 ? '#25ee89' : '#c0c0c0'};
//   border-radius: 50%;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   font-weight: bold;
//   font-size: 14px;
//   color: #1e2328;
  
//   @media (max-width: 768px) {
//     width: 20px;
//     height: 20px;
//     font-size: 12px;
//   }
// `;

// const moveUpAnimation = keyframes`
// //   0% { transform: translateY(10px); opacity: 0; }
// //   100% { transform: translateY(0); opacity: 1; }
// `;

// const TableRow = styled.tr`
//   background-color:transparent;
//   transition: background-color 0.3s ease;
// `;

// const AnimatedTableRow = styled(TableRow)`
//   animation: ${moveUpAnimation} 0.5s ease-out;
// `;

// const AnimatedTable = ({ data, visibleRowsCount = 10 }) => {
//   const [visibleData, setVisibleData] = useState([]);
//   const [startIndex, setStartIndex] = useState(0);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setStartIndex((prevIndex) => (prevIndex + 1) % (data.length - visibleRowsCount + 1));
//     }, 1000);

//     return () => clearInterval(interval);
//   }, [data.length, visibleRowsCount]);

//   useEffect(() => {
//     setVisibleData(data.slice(startIndex, startIndex + visibleRowsCount));
//   }, [startIndex, data, visibleRowsCount]);

//   return (
//     <TableWrapper>
//       <Table>
//         <thead>
//           <tr>
//             <TableHeader style={{color:'#99A4B0', fontWeight:'bold'}}>Game</TableHeader>
//             <TableHeader style={{color:'#99A4B0', fontWeight:'bold'}}>Player</TableHeader>
//             <TableHeader style={{color:'#99A4B0', fontWeight:'bold'}}>Bet ID</TableHeader>
//             <TableHeader style={{color:'#99A4B0', fontWeight:'bold'}}>Payout</TableHeader>
//             <TableHeader style={{color:'#99A4B0', fontWeight:'bold'}}>Profit</TableHeader>
//           </tr>
//         </thead>
//         <tbody>
//           {visibleData.map((row, index) => (
//             <AnimatedTableRow key={`${startIndex}-${index}`} even={index % 2 === 0}>
//                <TableCell>
//                 <div style={{display:'flex', gap:"4px", alignItems: "center"}}>
//                   <img src={row.gameImagePath} style={{height:"16px", width:"16px", borderRadius:"50%"}}/>
//                   <div>{row.game}</div>
//                 </div>
//               </TableCell>
//               <TableCell style={{fontWeight:'bold'}}>{row.user}</TableCell>
//               <TableCell className="betid-cell" style={{color:'#99A4B0', fontWeight:'bold'}}>{row.time}</TableCell>
//               <TableCell style={{color:'#99A4B0', fontWeight:'bold'}}>{row.amount}</TableCell>
//               <TableCell>
//                 <div style={{display:'flex', gap:"4px", alignItems: "center"}}>
//                   <img src={row.path} style={{height:"16px", width:"16px", borderRadius:"50%"}}/>
//                   <GreenText>{row.multiplier}</GreenText>
//                 </div>
//               </TableCell>
//             </AnimatedTableRow>
//           ))}
//         </tbody>
//       </Table>
//     </TableWrapper>
//   );
// };
// function CasinoLeaderboard() {
//   const [activeTab, setActiveTab] = useState('Social Casino');

//   const socialCasinoData = [
//     {
//       "game": "Bimbo",
//       "user": "Hidden",
//       "time": "1632849275847",
//       "amount": "0.87x",
//       "multiplier": "0.038485000",
//       "gameImagePath": "/assets/images/icons/limbo.png",
//       "path": "/assets/images/BTC.png"
//     },
//     {
//       "game": "Classic Dice",
//       "user": "Hidden",
//       "time": "1598376492837",
//       "amount": "2.34x",
//       "multiplier": "0.045672000",
//       "gameImagePath": "/assets/images/icons/classic_dice.png",
//       "path": "/assets/images/USDT.png"
//     },
//     {
//       "game": "Plinko",
//       "user": "Hidden",
//       "time": "1612938475629",
//       "amount": "0.05x",
//       "multiplier": "0.029384000",
//       "gameImagePath": "/assets/images/icons/plinko.png",
//       "path": "/assets/images/ETH.png"
//     },
//     {
//       "game": "Hash Dice",
//       "user": "Hidden",
//       "time": "1645029384756",
//       "amount": "1.76x",
//       "multiplier": "0.052937000",
//       "gameImagePath": "/assets/images/icons/hashdice.png",
//       "path": "/assets/images/DOGE.png"
//     },
//     {
//       "game": "Wheel",
//       "user": "Hidden",
//       "time": "1678394857263",
//       "amount": "3.21x",
//       "multiplier": "0.061284000",
//       "gameImagePath": "/assets/images/icons/wheel.png",
//       "path": "/assets/images/EOS.png"
//     },
//     {
//       "game": "Limbo",
//       "user": "Hidden",
//       "time": "1623948576234",
//       "amount": "0.12x",
//       "multiplier": "0.033765000",
//       "gameImagePath": "/assets/images/icons/limbo.png",
//       "path": "/assets/images/BTC.png"
//     },
//     {
//       "game": "Classic Dice",
//       "user": "Hidden",
//       "time": "1609283746592",
//       "amount": "4.98x",
//       "multiplier": "0.078392000",
//       "gameImagePath": "/assets/images/icons/classic_dice.png",
//       "path": "/assets/images/USDT.png"
//     },
//     {
//       "game": "Plinko",
//       "user": "Hidden",
//       "time": "1656293847569",
//       "amount": "0.54x",
//       "multiplier": "0.041593000",
//       "gameImagePath": "/assets/images/icons/plinko.png",
//       "path": "/assets/images/ETH.png"
//     },
//     {
//       "game": "Hash Dice",
//       "user": "Hidden",
//       "time": "1687439275634",
//       "amount": "1.23x",
//       "multiplier": "0.049281000",
//       "gameImagePath": "/assets/images/icons/hashdice.png",
//       "path": "/assets/images/DOGE.png"
//     },
//     {
//       "game": "Wheel",
//       "user": "Hidden",
//       "time": "1634958273645",
//       "amount": "5.67x",
//       "multiplier": "0.082746000",
//       "gameImagePath": "/assets/images/icons/wheel.png",
//       "path": "/assets/images/EOS.png"
//     },
//     {
//       "game": "Limbo",
//       "user": "Hidden",
//       "time": "1601234567890",
//       "amount": "0.03x",
//       "multiplier": "0.031245000",
//       "gameImagePath": "/assets/images/icons/limbo.png",
//       "path": "/assets/images/BTC.png"
//     },
//     {
//       "game": "Classic Dice",
//       "user": "Hidden",
//       "time": "1678901234567",
//       "amount": "2.89x",
//       "multiplier": "0.057382000",
//       "gameImagePath": "/assets/images/icons/classic_dice.png",
//       "path": "/assets/images/USDT.png"
//     },
//     {
//       "game": "Plinko",
//       "user": "Hidden",
//       "time": "1645678901234",
//       "amount": "0.76x",
//       "multiplier": "0.043921000",
//       "gameImagePath": "/assets/images/icons/plinko.png",
//       "path": "/assets/images/ETH.png"
//     },
//     {
//       "game": "Hash Dice",
//       "user": "Hidden",
//       "time": "1612345678901",
//       "amount": "3.45x",
//       "multiplier": "0.064829000",
//       "gameImagePath": "/assets/images/icons/hashdice.png",
//       "path": "/assets/images/DOGE.png"
//     },
//     {
//       "game": "Wheel",
//       "user": "Hidden",
//       "time": "1689012345678",
//       "amount": "1.98x",
//       "multiplier": "0.053678000",
//       "gameImagePath": "/assets/images/icons/wheel.png",
//       "path": "/assets/images/EOS.png"
//     },
//     {
//       "game": "Limbo",
//       "user": "Hidden",
//       "time": "1656789012345",
//       "amount": "0.34x",
//       "multiplier": "0.037492000",
//       "gameImagePath": "/assets/images/icons/limbo.png",
//       "path": "/assets/images/BTC.png"
//     },
//     {
//       "game": "Classic Dice",
//       "user": "Hidden",
//       "time": "1623456789012",
//       "amount": "4.21x",
//       "multiplier": "0.072345000",
//       "gameImagePath": "/assets/images/icons/classic_dice.png",
//       "path": "/assets/images/USDT.png"
//     },
//     {
//       "game": "Plinko",
//       "user": "Hidden",
//       "time": "1690123456789",
//       "amount": "0.09x",
//       "multiplier": "0.032178000",
//       "gameImagePath": "/assets/images/icons/plinko.png",
//       "path": "/assets/images/ETH.png"
//     },
//     {
//       "game": "Hash Dice",
//       "user": "Hidden",
//       "time": "1657890123456",
//       "amount": "5.87x",
//       "multiplier": "0.086543000",
//       "gameImagePath": "/assets/images/icons/hashdice.png",
//       "path": "/assets/images/DOGE.png"
//     },
//     {
//       "game": "Wheel",
//       "user": "Hidden",
//       "time": "1624567890123",
//       "amount": "2.56x",
//       "multiplier": "0.058921000",
//       "gameImagePath": "/assets/images/icons/wheel.png",
//       "path": "/assets/images/EOS.png"
//     }
//   ];

//   const raceLeaderboardData = [
//     { rank: 1, user: 'Hidden', played: '15,530,015,3...', prize: '7,000,000.00' },
//     { rank: 2, user: 'Hidden', played: '348,911,530,...', prize: '4,750,000.00' },
//     // Add more data as needed
//   ];

//   return (

//     <div style={{marginTop:'12px'}}>
    
//     <div>
//     <TabSwitcher>
//         <Tab active={activeTab === 'Social Casino'} onClick={() => setActiveTab('Social Casino')}>Latest Wins</Tab>
//         {/* <Tab active={activeTab === 'Contest'} >Contest</Tab> */}
//       </TabSwitcher>
//     </div>
//     <Container>
     
      
//       {activeTab === 'Social Casino' && (
//         <AnimatedTable data={socialCasinoData} />
//       )}
      
//       {activeTab === 'Race Leaderboard' && (
//         <>
//        <div>Sample</div>
//         </>
//       )}
//     </Container>
//     </div>
//   );
// }

// export default CasinoLeaderboard;

import { useState, useEffect } from "react"
import styles from "./LatestWins.module.css"
import { useGameLaunch } from "../../../Context/GameLaunchContext"
import { launchHuiduGame } from "../../../services/huiduGameService"
import { getUID, sendNotfication } from "../../../Helper"
import { FaPlane, FaRocket, FaBolt, FaDrum, FaCandyCane, FaBomb, FaRegCreditCard, FaDice, FaFish, FaCaretDown, FaHorse } from "react-icons/fa"

const games = [
  { name: "Aviator", icon: <FaPlane size={20} color="#7b8a8e" />, className: "wheel", game_uid: "a04d1f3eb8ccec8a4823bdf18e3f0e84" },
  { name: "JetX", icon: <FaRocket size={20} color="#7b8a8e" />, className: "limbo", game_uid: "2e815f80a5a87b0255c130c00d95a71e" },
  { name: "Horse Racing", icon: <FaHorse size={20} color="#7b8a8e" />, className: "plinko", game_uid: "883580d090b1790a06fcfe8ea255272a" },
  { name: "Lightning Roulette", icon: <FaBolt size={20} color="#7b8a8e" />, className: "hashDice", game_uid: "4a858d6b74c05260d3ea2762838798c7" },
  { name: "Chicken Love", icon: <FaDrum size={20} color="#7b8a8e" />, className: "wheel", game_uid: "b5e693cdae7f862e5d0198550db0a413" },
  { name: "Sugar Ride", icon: <FaCandyCane size={20} color="#7b8a8e" />, className: "classicDice", game_uid: "55b4abd7ea22e78069c5a85b42da59b6" },
  { name: "Mines", icon: <FaBomb size={20} color="#7b8a8e" />, className: "limbo", game_uid: "b3d92fb446a2829a06f828ec83f432f4" },
  { name: "Andar Bahar", icon: <FaRegCreditCard size={20} color="#7b8a8e" />, className: "hashDice", game_uid: "435b892a73bf466e0ad584d480e12143" },
  { name: "Mahjong Ways", icon: <FaDice size={20} color="#7b8a8e" />, className: "plinko", game_uid: "1189baca156e1bbbecc3b26651a63565" },
  { name: "Royal Fishing", icon: <FaFish size={20} color="#7b8a8e" />, className: "classicDice", game_uid: "e794bf5717aca371152df192341fe68b" },
]

const currencies = [
  { name: "BTC", className: "btc" },
  { name: "ETH", className: "eth" },
  { name: "LTC", className: "ltc" },
  { name: "DOGE", className: "doge" },
  { name: "BCH", className: "bch" },
]

// Name parts for username generation
const nameParts = [
  "Crypto",
  "Bitcoin",
  "Satoshi",
  "Hodl",
  "Moon",
  "Rocket",
  "Diamond",
  "Whale",
  "Bull",
  "Bear",
  "Degen",
  "Ape",
  "Chain",
  "Block",
  "Hash",
  "Simon",
  "Alex",
  "Max",
  "Elon",
  "Vital",
  "Sam",
  "Mike",
  "John",
  "Lisa",
  "Emma",
  "Sophia",
  "Jack",
  "Ryan",
  "Gia",
  "Leo",
  "Zack",
]

const nameSuffixes = [
  "TheMoon",
  "Hodler",
  "Trader",
  "Winner",
  "Pro",
  "Master",
  "King",
  "Queen",
  "Guru",
  "Wizard",
  "Ninja",
  "Whale",
  "Shark",
  "Hunter",
  "Boss",
]

// Track used usernames to ensure uniqueness
const usedUsernames = new Set()

// Generate a unique username
function generateUsername() {
  let username = ""
  let attempts = 0

  do {
    // Different username patterns
    const pattern = Math.floor(Math.random() * 5)

    switch (pattern) {
      case 0: // Name + Numbers + Suffix
        username = `${nameParts[Math.floor(Math.random() * nameParts.length)]}${Math.floor(Math.random() * 10000)}${nameSuffixes[Math.floor(Math.random() * nameSuffixes.length)]}`
        break
      case 1: // Name + Numbers
        username = `${nameParts[Math.floor(Math.random() * nameParts.length)]}${Math.floor(Math.random() * 100000)}`
        break
      case 2: // Name + Name + Numbers
        username = `${nameParts[Math.floor(Math.random() * nameParts.length)]}${nameParts[Math.floor(Math.random() * nameParts.length)]}${Math.floor(Math.random() * 1000)}`
        break
      case 3: // Name + Numbers + Name + Numbers
        username = `${nameParts[Math.floor(Math.random() * nameParts.length)]}${Math.floor(Math.random() * 1000)}${nameParts[Math.floor(Math.random() * nameParts.length)]}${Math.floor(Math.random() * 100)}`
        break
      case 4: // Special pattern with underscores or dashes
        username = `${nameParts[Math.floor(Math.random() * nameParts.length)]}${Math.random() > 0.5 ? "_" : "-"}${nameParts[Math.floor(Math.random() * nameParts.length)]}${Math.floor(Math.random() * 1000)}`
        break
    }

    attempts++
    // Prevent infinite loops
    if (attempts > 100) {
      username = `User${Math.random().toString(20).substring(2, 10)}`
      break
    }
  } while (usedUsernames.has(username))

  usedUsernames.add(username)
  return username
}

function generateRandomBet() {
  const game = games[Math.floor(Math.random() * games.length)]
  const currency = currencies[Math.floor(Math.random() * currencies.length)]
  const payout = (Math.random() * 10).toFixed(2)
  const profit = (Math.random() * 20).toFixed(2)
  const betId = Math.floor(Math.random() * 900000000) + 100000000

  return {
    id: Math.random().toString(36).substr(2, 9),
    game,
    player: generateUsername(),
    betId: betId.toString(),
    payout: `${payout}x`,
    profit: {
      amount: profit,
      currency: currency,
    },
    isNew: true,
  }
}

// Generate initial bets with unique usernames
const initialBets = Array.from({ length: 9 }, (_, i) => {
  const game = games[Math.floor(Math.random() * games.length)]
  const currency = currencies[Math.floor(Math.random() * currencies.length)]
  const payout = (Math.random() * 10).toFixed(2)
  const profit = (Math.random() * 0.1).toFixed(2)
  const betId = Math.floor(Math.random() * 900000000) + 100000000

  return {
    id: `initial-${i}`,
    game,
    player: generateUsername(),
    betId: betId.toString(),
    payout: `${payout}x`,
    profit: {
      amount: profit,
      currency,
    },
    isNew: false,
  }
})

export default function LatestWins() {
  const [bets, setBets] = useState(initialBets)
  const [isShifting, setIsShifting] = useState(false)
  const { setGameUrl, setIsGameOpen } = useGameLaunch()

  const handleGameClick = async (game) => {
    const id = getUID();
    if (!id) {
      sendNotfication('Please login to play', 'error');
      return;
    }
    try {
      const credits = localStorage.getItem('credit') || '0';
      const coins = localStorage.getItem('coin') || 'INR';
      const result = await launchHuiduGame(game.game_uid, id, credits, coins);
      if (result && result.game_launch_url) {
        setGameUrl(result.game_launch_url);
        setIsGameOpen(true);
      } else {
        sendNotfication('Failed to launch game', 'error');
      }
    } catch (error) {
      sendNotfication(error.message || 'Failed to launch game', 'error');
    }
  }

  useEffect(() => {
    const interval = setInterval(() => {
      // Trigger shift animation for existing rows
      setIsShifting(true)

      // Add new bet after a short delay to sync with shift animation
      setTimeout(() => {
        const newBet = generateRandomBet()
        setBets((prevBets) => {
          // Always maintain exactly 10 rows
          const updatedBets = [newBet, ...prevBets.slice(0, 9)]
          // Only mark the new bet as new
          return updatedBets.map((bet, index) => ({
            ...bet,
            isNew: index === 0,
          }))
        })
        setIsShifting(false)
      }, 150) // Small delay to allow shift animation to start
    }, 3000)

    return () => clearInterval(interval)
  }, [])

  return (
    <div className={styles.container}>
      <div className={styles.tableWrapper}>
        {/* Header */}
        <div className={styles.header}>
          <div>Game</div>
          <div>Player</div>
          <div>Bet ID</div>
          <div>Payout</div>
          <div>Profit</div>
        </div>

        {/* Bet Rows - Always exactly 10 rows */}
        <div>
          {bets.map((bet, index) => (
            <div
              key={bet.id}
              className={`${styles.betRow} ${bet.isNew ? styles.new : ""} ${isShifting && !bet.isNew ? styles.shifting : ""}`}
              onClick={() => handleGameClick(bet.game)}
              style={{ cursor: 'pointer' }}
            >
              {/* Game */}
              <div className={styles.gameCell}>
                <div className={`${styles.gameIcon} ${styles[bet.game.className]}`}>{bet.game.icon}</div>
                <span className={styles.gameName}>{bet.game.name}</span>
              </div>

              {/* Player */}
              <div className={styles.playerCell}>
                <span className={styles.playerName}>{bet.player}</span>
              </div>

              {/* Bet ID */}
              <div className={styles.betIdCell}>
                <span className={styles.betId}>{bet.betId}</span>
              </div>

              {/* Payout */}
              <div className={styles.payoutCell}>
                <span className={styles.payout}>{bet.payout}</span>
              </div>

              {/* Profit */}
              <div className={styles.profitCell}>
                <div className={` ${styles[bet.profit.currency.className]}`}></div>
                <span className={styles.profitAmount}>${bet.profit.amount}k</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}